import { render, staticRenderFns } from "./WhatsappIconBack.vue?vue&type=template&id=6ffb9970&"
import script from "./WhatsappIconBack.vue?vue&type=script&lang=js&"
export * from "./WhatsappIconBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports